export var AccountReactivationIA = function AccountReactivationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ACCOUNT_REACTIVATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize)];
    }
  };
};
var ACCOUNT_REACTIVATION_TITLE = function ACCOUNT_REACTIVATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "pEaCXm",
    defaultMessage: [{
      "type": 0,
      "value": "Réactiver le compte"
    }]
  });
};
var ACCOUNT_REACTIVATION_DESCRIPTION = function ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "xhsL1w",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous avez déjà désactivé votre compte, vous pouvez envoyer une demande de réactivation à l'aide de l'option « Nous contacter » ci-dessous. Remarque : pour effectuer une demande de vérification de votre compte, accédez à Mon compte > Intégration > Vérification du compte"
    }]
  });
};